export default "__VITE_ASSET__C4RVYs4I__"